export class TimeSpan {

	public days!: number;
	public hours!: number;
	public minutes!: number;
	public seconds!: number;

	constructor(timeSpan: TimeSpan) {

		this.days = timeSpan.days;
		this.hours = timeSpan.hours;
		this.minutes = timeSpan.minutes;
		this.seconds = timeSpan.seconds;
	}

	public toString = (): string => {

		return TimeSpan.toString(this);
	}

	public static toString = (timeSpan: TimeSpan): string => {

		const hours: string = timeSpan.hours.toString().padStart(2, "0");
		const minutes: string = timeSpan.minutes.toString().padStart(2, "0");
		const seconds: string = timeSpan.seconds.toString().padStart(2, "0");

		return `${hours}:${minutes}:${seconds}`;
	}
}
